module.exports = __webpack_public_path__ + "media/coffee-preferences/equitable_trade_anything_is_fine-fb9d4965.png";